import { t } from '@if/core/i18n'
import { Box, Card, CardContent, Switch, Typography } from '@mui/material'
import { FraudFlagReasonDialog } from '@src/containers/FraudFlagsPage/components/FraudFlagReasonDialog'
import { FraudFlagDto } from '@src/data/api/fraud/fraud-api'
import { useUpdateFraudFlag } from '@src/data/api/fraud/useFraud'
import { useState } from 'react'


interface documentFraudFlagsCardProps {
  flag: FraudFlagDto
  indicatorType: string
  currentLanguage: string
  financingProgramId: string
  creditApplicationId: string
  selectedPagesIds?: string[]
}
const DocumentFraudFlagsCard: React.FC<documentFraudFlagsCardProps> = ({
  flag,
  indicatorType,
  currentLanguage,
  financingProgramId,
  creditApplicationId,
  selectedPagesIds,
}) => {
  const [updateFraudFlag, isUpdatingFlag] = useUpdateFraudFlag()
  const [showReasonDialog, setShowReasonDialog] = useState(false)
  const [reason, setReason] = useState('')
  const [pendingValue, setPendingValue] = useState(false)

  const displayName = currentLanguage === 'fr' ? flag.displayNameFr : flag.displayNameEn

  const handleToggle = () => {
    if (flag.isAutomatic) {
      return // Don't allow toggling automatic flags
    }
    setPendingValue(!flag.value)
    setShowReasonDialog(true)
  }

  const handleConfirmToggle = async () => {
    try {
      await updateFraudFlag({
        financingProgramId,
        creditApplicationId,
        indicatorType,
        flagKey: flag.key,
        request: {
          value: pendingValue,
          reason,
          documentIds: selectedPagesIds || [],
        },
      })
      setShowReasonDialog(false)
      setReason('')
    } catch (error) {
      console.error('Failed to update flag:', error)
    }
  }

  const handleCancelToggle = () => {
    setShowReasonDialog(false)
    setReason('')
    setPendingValue(flag.value)
  }

  return (
    <>
      <Card
        sx={{
          width: '100%',
          borderLeft: 4,
          borderLeftColor: flag.value ? 'error.main' : 'divider',
          bgcolor: flag.value ? 'error.50' : 'background.paper',
        }}
      >
        <CardContent>
          <Typography variant="subtitle2" component="div" sx={{ flex: 1 }}>
            {displayName}
          </Typography>

          {flag.value && flag.reason && (
            <Box sx={{ mt: 1, p: 1, bgcolor: 'background.paper', borderRadius: 1 }}>
              <Typography variant="caption" color="text.primary" display="block" fontWeight="medium">
                {t('fraudFlags.reasonLabel')}:
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block">
                {flag.reason}
              </Typography>
            </Box>
          )}
          <Typography variant="caption" color="text.secondary" display="block">
            <Switch
              sx={{ alignSelf: 'flex-end' }}
              disabled={flag.isAutomatic || isUpdatingFlag || (selectedPagesIds?.length === 0 && !flag.value)}
              checked={flag.value}
              onChange={handleToggle}
              color={'error'}
            />
          </Typography>
        </CardContent>
      </Card>
      
      <FraudFlagReasonDialog
        showReasonDialog={showReasonDialog}
        pendingValue={pendingValue}
        displayName={displayName}
        isUpdatingFlag={isUpdatingFlag}
        reason={reason}
        setReason={setReason}
        handleConfirmToggle={handleConfirmToggle}
        handleCancelToggle={handleCancelToggle}
      />
    </>
  )
}

export default DocumentFraudFlagsCard